module.exports = __webpack_public_path__ + "img/broncos-nav-logo.ad6d0b87.png";